import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../util/assets';
import Logo from '../../../../../../components/global/Logo';
import { SEARCH_MODES } from '../AlbumSearchForm/AlbumSearchForm';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  searchMode: PropTypes.string.isRequired,
};

const NullState = ({ searchMode }) => {
  const content = (() => {
    switch (searchMode) {
      case SEARCH_MODES.USER:
        return {
          description: (
            <p>
              Enter a user&rsquo;s name or Waldo username to find &amp; join
              their events.
            </p>
          ),
          image: 'search-users.png',
          title: 'Search People',
        };
      case SEARCH_MODES.LOCATION:
        return {
          description: (
            <p>Enter an address or venue above to find Waldo-fied events</p>
          ),
          image: 'search-places.png',
          title: 'Search Places',
        };
      case SEARCH_MODES.PRO_DIRECTORY:
        // TODO: add link to apply here.
        return {
          description: (
            <Fragment>
              <p>
                Enter the location of your event in the search box above to find
                a professional photographer for your event.
              </p>

              <p>
                Are you a Pro Photographer?{' '}
                <Button
                  btnStyle="link"
                  href="/auth/register?source=WALDO_SEARCH"
                  target="_blank"
                >
                  Apply here.
                </Button>
              </p>
            </Fragment>
          ),
          image: 'search-places.png',
          title: 'Looking for a Waldo-fied photographer for your event?',
        };
      case SEARCH_MODES.JOIN_CODE:
        return {
          description: (
            <p>
              Enter a join code above to directly join an event so I can find
              &amp; deliver your photos
            </p>
          ),
          image: 'search-albums.png',
          title: 'Search Join Codes',
        };
      case SEARCH_MODES.EVENTS:
      default:
        return {
          description: (
            <Fragment>
              <p>Enter the name of your event in the search bar above.</p>
              <p className="text-sm">
                <em>Note</em>: Personal events are all private.
                <br />
                If you want to join a private event, ask the organizer for a
                link or join code.
              </p>
            </Fragment>
          ),
          image: 'search-albums.png',
          title: 'Search Events',
        };
    }
  })();

  return (
    <div className="row">
      <div className="col-12">
        <div className="search-results-null-state">
          <Logo
            className="waldo-icon-search-null-state"
            iconOnly
            imageProps={{ height: '48px' }}
          />
          <h4 className="mt-2 text-dark">{content.title}</h4>
          {content.description}
          <img
            alt={content.title}
            className="search-null-state-graphic"
            src={getAsset(`/web-galleries/images/${content.image}`)}
          />
        </div>
      </div>
    </div>
  );
};

NullState.propTypes = propTypes;

export default NullState;
